<template>
  <ul class="files d-b f-v">
    <template v-for="(file, idx) in files">
      <li
        v-if="!file.errors"
        :key="`file-${idx}`"
      >
        <donut-upload-item
          :ref="`file-${idx}`"
          :file="file"
          :sortability="{ idx: idx, display: allowSorting && files.length > 1, up: idx > 0, down: idx < files.length - 1 }"
        />
      </li>
      <li
        v-if="file.errors"
        :key="`file-${idx}`"
        class="br bg-red p-l12 p-v10 p-rx2"
      >
        <div class="t red f-v">
          <strong>{{ file.name }} failed to upload</strong>
          <span v-if="file.errors.extension">Sorry, that file type is not supported.</span>
          <span v-else-if="file.errors.host">Sorry, that host is not supported.</span>
          <span v-else-if="file.errors.file_size">Sorry, we do not support files that large.</span>
          <span v-else-if="file.errors.failed_processing">
            Sorry, this file failed to process. Please make sure your file is
            formatted correctly and try uploading it again. If the problem
            persists, contact support.
          </span>
          <span v-else>Sorry, something went wrong while uploading your file.</span>
        </div>
      </li>
    </template>
  </ul>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();

  const props = defineProps({
    allowSorting: { type: Boolean, default: false },
  });

  const files = computed(() => state.uploads.files);
</script>
